module.exports = {"Assignment":"انتساب"}